import type { Platforms } from "@/content/site";

const LABELS: [string, keyof Platforms][] = [
  ["Spotify", "spotify"],
  ["Apple Music", "appleMusic"],
  ["YouTube Music", "youtubeMusic"],
];

const slug = (s: string) => s.toLowerCase().replace(/\s+/g, "-");

export function StreamRow({
  platforms,
  testPrefix,
  compact = false,
}: {
  platforms: Platforms;
  testPrefix: string;
  compact?: boolean;
}) {
  const entries = compact ? LABELS.filter(([, key]) => platforms[key]) : LABELS;
  return (
    <div className="flex flex-wrap items-center gap-2.5" data-testid={`${testPrefix}-stream-row`}>
      {entries.map(([name, key]) => {
        const url = platforms[key];
        return url ? (
          <a
            key={name}
            data-testid={`${testPrefix}-${slug(name)}-link`}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className={`border border-white/20 font-mono uppercase tracking-[0.25em] text-eve-ink transition-all duration-300 hover:border-eve-cyan hover:text-eve-cyan ${
              compact ? "px-3 py-2 text-[9px]" : "px-4 py-2.5 text-[10px]"
            }`}
          >
            {name} ↗
          </a>
        ) : (
          <span
            key={name}
            title="Official link pending — add the URL in content settings"
            className="cursor-default border border-white/10 px-4 py-2.5 font-mono text-[10px] uppercase tracking-[0.25em] text-white/35"
          >
            {name} · pending
          </span>
        );
      })}
    </div>
  );
}
